export default __webpack_public_path__ + "static/media/nobel_logo.76ee41d1.png";